<template>
	<div id="header">
		<div class="greenline"></div>
		<div class="info">
			<div class="menu_compacto float-left" @blur="closeMenu" tabindex="0">
				<div @click="openMenu(true)" class="container-bars">
					<div class="bars"></div>
					<div class="bars"></div>
					<div class="bars"></div>
				</div>
				<div class="menu" :class="[showMenu ? 'menu_show' : '']">
					<ul>
						<li @click="navigateTo($event, { path: '/overviews' })" @click.middle="navigateTo($event, { path: '/overviews' })" v-if="permission('overviews', 'select')" @mouseenter="subMenu()">
							{{$t('menu_overview')}}
						</li><!-- visão geral -->

						<li @click="navigateTo($event, { path: '/news' })" @click.middle="navigateTo($event, { path: '/news' })" v-if="permission('news', 'select')" @mouseenter="subMenu()">
							{{$t('menu_news')}}
						</li><!-- avisos -->

						<li @click="navigateTo($event, { path: '/searchorder' })" @click.middle="navigateTo($event, { path: '/searchorder' })" v-if="permission('searchorder', 'select')" @mouseenter="subMenu()">
							{{$t('menu_search_order')}}
						</li><!-- buscar ordem -->

						<li	v-if="	permission('updateinformation',	'select') ||
									permission('accountconfig',		'select') ||
									permission('accountproduct',	'select') ||
									permission('accountfee',		'select') ||
									permission('accountemail',		'select') ||
									permission('accountuserlist',	'select') ||
									permission('blocklistroaming',	'select')"
							@click="subMenu('showMenuAccount')"
							@mouseenter="subMenu('showMenuAccount')">

							{{$t('menu_update_information')}}

							<div id="menu_account" class="submenu" :class="[showMenuAccount ? 'menu_show' : '']">
								<li @click="navigateTo($event, { path: '/updateinformation' })"	@click.middle="navigateTo($event, { path: '/updateinformation' })"	class="dropdown-item" v-if="permission('updateinformation',	'select')">{{$t('ui_account_sub')}}</li>
								<li @click="navigateTo($event, { path: '/accountconfig' })"		@click.middle="navigateTo($event, { path: '/accountconfig' })"		class="dropdown-item" v-if="permission('accountconfig',		'select')">{{$t('ui_config_title')}}</li>
								<li @click="navigateTo($event, { path: '/accountproduct' })"	@click.middle="navigateTo($event, { path: '/accountproduct' })"		class="dropdown-item" v-if="permission('accountproduct',	'select')">{{$t('menu_account_product')}}</li>
								<li @click="navigateTo($event, { path: '/accountfee' })"		@click.middle="navigateTo($event, { path: '/accountfee' })"			class="dropdown-item" v-if="permission('accountfee',		'select')">{{$t('ui_fee_title')}}</li>
								<li @click="navigateTo($event, { path: '/accountshopify' })"	@click.middle="navigateTo($event, { path: '/accountshopify' })"		class="dropdown-item" v-if="permission('accountshopify',	'select') && this.shopify == 1">Shopify</li>
								<li @click="navigateTo($event, { path: '/accountemail' })"		@click.middle="navigateTo($event, { path: '/accountemail' })"		class="dropdown-item" v-if="permission('accountemail',		'select')">{{$t('ui_email_title')}}</li>
								<li @click="navigateTo($event, { path: '/accountuserlist' })"	@click.middle="navigateTo($event, { path: '/accountuserlist' })"	class="dropdown-item" v-if="permission('accountuserlist',	'select')">{{$t('menu_account_user_list')}}</li>
								<li @click="navigateTo($event, { path: '/blocklistroaming' })"	@click.middle="navigateTo($event, { path: '/blocklistroaming' })"	class="dropdown-item" v-if="permission('blocklistroaming',	'select')">{{$t('menu_blocklist_pix_roaming')}}</li>
							</div>
						</li><!-- conta -->

						<li v-if="permission('reports', 'select')" @click="subMenu('showMenuReport')" @mouseenter="subMenu('showMenuReport')">

							{{$t('menu_reports')}}

							<div id="menu_report" class="submenu" :class="[showMenuReport ? 'menu_show' : '']">
								<li @click="navigateTo($event, { path: '/settlementreport' })"	@click.middle="navigateTo($event, { path: '/settlementreport' })"	class="dropdown-item" >{{$t('menu_settlement_reports')}}</li>
								<li @click="navigateTo($event, { path: '/salesreport' })"		@click.middle="navigateTo($event, { path: '/salesreport' })"		class="dropdown-item" >{{$t('menu_sales_reports')}}</li>
								<li @click="navigateTo($event, { path: '/commissionreport' })"	@click.middle="navigateTo($event, { path: '/commissionreport' })"	class="dropdown-item" v-show="realxpp == '*' && merchant_cid != ''">{{$t('menu_commission_reports')}}</li>
								<!-- <li @click="navigateTo($event, { path: '/graphicreport' })"		@click.middle="navigateTo($event, { path: '/graphicreport' })"		class="dropdown-item" >{{$t('menu_graphics')}}</li> -->
								<li @click="navigateTo($event, { path: '/refundreport' })"		@click.middle="navigateTo($event, { path: '/refundreport' })"		class="dropdown-item" v-if="permission('refundreport',		'select')">{{$t('menu_refund_report')}}</li>
								<li @click="navigateTo($event, { path: '/podreport' })"			@click.middle="navigateTo($event, { path: '/podreport' })"			class="dropdown-item" v-if="permission('podreport',			'select')">{{$t('menu_pod_report')}}</li>
								<li @click="navigateTo($event, { path: '/gateway' })"			@click.middle="navigateTo($event, { path: '/gateway' })"			class="dropdown-item" v-if="permission('gateway',			'select') && gateway != '' ">{{$t('menu_gateway')}}</li>
								<li @click="navigateTo($event, { path: '/pagshieldreport' })"	@click.middle="navigateTo($event, { path: '/pagshieldreport' })"	class="dropdown-item" v-if="permission('pagshieldreport',	'select')">{{$t('menu_pagshieldreport')}}</li>
								<li
									@click="navigateTo($event, { path: '/remittanceschedule' })"
									@click.middle="navigateTo($event, { path: '/remittanceschedule' })"
									class="dropdown-item"
									v-if="permission('remittanceschedule', 'select')">{{$t('menu_repasse_agendado')}}</li>
								<li
									@click="navigateTo($event, { path: '/remittanceanticipation' })"
									@click.middle="navigateTo($event, { path: '/remittanceanticipation' })"
									class="dropdown-item"
									v-if="permission('remittanceanticipation', 'select')">{{$t('menu_antecipacao_repasse')}}</li>
								<li
									@click="navigateTo($event, { path: '/unidaderecebivel' })"
									@click.middle="navigateTo($event, { path: '/unidaderecebivel' })"
									class="dropdown-item"
									v-if="permission('unidaderecebivel', 'select')">CERC {{$t('menu_unidade_recebivel')}}</li>
								<li
									@click="navigateTo($event, { path: '/poscontratada' })"
									@click.middle="navigateTo($event, { path: '/poscontratada' })"
									class="dropdown-item"
									v-if="permission('poscontratada', 'select')">CERC {{$t('menu_pos_contratada')}}</li>
								<li
									@click="navigateTo($event, { path: '/efeitocontrato' })"
									@click.middle="navigateTo($event, { path: '/efeitocontrato' })"
									class="dropdown-item"
									v-if="permission('efeitocontrato', 'select')">CERC {{$t('menu_efeito_contrato')}}</li>
							</div>
						</li><!-- relatórios -->

						<li	v-if="	(permission('catalogocategoria', 'select') ||
									permission('catalogoproduto',	'select'))"
							@click="subMenu('showMenuCatalogo')"
							@mouseenter="subMenu('showMenuCatalogo')">

							{{$t('menu_catalogo')}}

							<div id="menu_catalogo" class="submenu" :class="[showMenuCatalogo ? 'menu_show' : '']">
								<li @click="navigateTo($event, { path: '/catalogocategoria' })"	@click.middle="navigateTo($event, { path: '/catalogocategoria' })"	class="dropdown-item" v-if="permission('catalogocategoria',	'select')">{{$t('menu_catalogo_categoria')}}</li>
								<li @click="navigateTo($event, { path: '/catalogoproduto' })"	@click.middle="navigateTo($event, { path: '/catalogoproduto' })"	class="dropdown-item" v-if="permission('catalogoproduto',	'select')">{{$t('menu_catalogo_produto')}}</li>
							</div>
						</li><!-- catálogo de produtos -->

						<li v-if="autorecurring == 1 &&
								(permission('autorecurringset',			'select') ||
								permission('autorecurringprom',			'select') ||
								permission('autorecurringautomation',	'select') ||
								permission('autorecurringproduct',		'select') ||
								permission('autorecurring',				'select') ||
								permission('autorecurringfreq',			'select') ||
								permission('autorecurringshipping',		'select') ||
								permission('autorecurringnot',			'select') ||
								permission('autorecurringover',			'select') ||
								permission('autorecurringreports',		'select') ||
								permission('autorecurringcustomerarea',	'select'))"
							@click="subMenu('showMenuPagStream')"
							@mouseenter="subMenu('showMenuPagStream')">

							{{$t('menu_auto_recurring_title')}}

							<div id="menu_prod" class="submenu" :class="[showMenuPagStream ? 'menu_show' : '']">
								<li @click="navigateTo($event, { path: '/pagstream/overview' })"		@click.middle="navigateTo($event, { path: '/pagstream/overview' })"			class="dropdown-item" v-if="permission('autorecurringover',			'select')">{{$t('menu_auto_recurring_overview')}}</li>
								<li @click="navigateTo($event, { path: '/pagstream/subscription' })"	@click.middle="navigateTo($event, { path: '/pagstream/subscription' })"		class="dropdown-item" v-if="permission('autorecurring',				'select')">{{$t('menu_auto_recurring')}}</li>
								<li @click="navigateTo($event, { path: '/pagstream/customer_area' })"	@click.middle="navigateTo($event, { path: '/pagstream/customer_area' })"	class="dropdown-item" v-if="permission('autorecurringcustomerarea',	'select') && getPagstreamCustomerArea()">{{$t('menu_auto_recurring_customer_area')}}</li>
								<li @click="navigateTo($event, { path: '/pagstream/billing_cycle' })"	@click.middle="navigateTo($event, { path: '/pagstream/billing_cycle' })"	class="dropdown-item" v-if="permission('autorecurringfreq',			'select')">{{$t('menu_auto_recurring_frequency')}}</li>
								<li @click="navigateTo($event, { path: '/pagstream/shipping_cycle' })"	@click.middle="navigateTo($event, { path: '/pagstream/shipping_cycle' })"	class="dropdown-item" v-if="permission('autorecurringshipping',		'select')">{{$t('menu_auto_recurring_shipping_cycle')}}</li>
								<li @click="navigateTo($event, { path: '/pagstream/product' })"			@click.middle="navigateTo($event, { path: '/pagstream/product' })"			class="dropdown-item" v-if="permission('autorecurringproduct',		'select') && getPagstreamBySku()">{{$t('menu_pagstream_products')}}</li>
								<li @click="navigateTo($event, { path: '/pagstream/setting' })"			@click.middle="navigateTo($event, { path: '/pagstream/setting' })"			class="dropdown-item" v-if="permission('autorecurringset',			'select') && !getPagstreamBySku()">{{$t('menu_auto_recurring_rules')}}</li>
								<li @click="navigateTo($event, { path: '/pagstream/promotion' })"		@click.middle="navigateTo($event, { path: '/pagstream/promotion' })"		class="dropdown-item" v-if="permission('autorecurringprom',			'select')">{{$t('menu_auto_recurring_promotion')}}</li>
								<li @click="navigateTo($event, { path: '/pagstream/automation' })"		@click.middle="navigateTo($event, { path: '/pagstream/automation' })"		class="dropdown-item" v-if="permission('autorecurringautomation',	'select')">{{$t('menu_auto_recurring_automation')}}</li>
								<li @click="navigateTo($event, { path: '/pagstream/notification' })"	@click.middle="navigateTo($event, { path: '/pagstream/notification' })"		class="dropdown-item" v-if="permission('autorecurringnot',			'select')">{{$t('menu_auto_recurring_notification')}}</li>
								<li @click="navigateTo($event, { path: '/pagstream/report' })"			@click.middle="navigateTo($event, { path: '/pagstream/report' })"			class="dropdown-item" v-if="permission('autorecurringreports',		'select')">{{$t('menu_auto_recurring_reports')}}</li>
							</div>
						</li><!-- pagstream -->

						<li @click="navigateTo($event, { path: '/pagshield' })" @click.middle="navigateTo($event, { path: '/pagshield' })"  v-if="permission('pagshield', 'select')" @mouseenter="subMenu()">
							{{$t('menu_pagshield')}}
						</li><!-- pagshield -->

						<li
							v-if="(permission('paymentlink', 'select') && paylink == 1) || (permission('trial', 'select'))"
							@click="subMenu('showMenuCheckout')"
							@mouseenter="subMenu('showMenuCheckout')"
						>
							{{$t('menu_checkout')}}
							<div id="menu_checkout" class="submenu" :class="[showMenuCheckout ? 'menu_show' : '']">
								<li
									v-if="(permission('paymentlink', 'select') && paylink == 1)"
									@click="subMenuNivel1('showMenuPaymentLink')"
									@mouseenter="subMenuNivel1('showMenuPaymentLink')"
									class="dropdown-item"
								>
									{{$t('menu_offline_payment')}}
								</li>

								<!-- Adicionado mais um nivel para PaymentLink-->
								<div class="submenu submenu-nivel-1" :class="[showMenuPaymentLink ? 'menu_show' : '']">
									<li @click="navigateTo($event, { path: '/searchofflinepayment' })"	@click.middle="navigateTo($event, { path: '/searchofflinepayment' })"	class="dropdown-item">{{$t('search')}}</li>
									<li @click="navigateTo($event, { path: '/offlinepayment' })"		@click.middle="navigateTo($event, { path: '/offlinepayment' })"			class="dropdown-item">{{$t('menu_offline_payment_create')}}</li>
									<li @click="navigateTo($event, { path: '/favorecido' })"			@click.middle="navigateTo($event, { path: '/favorecido' })"				class="dropdown-item">{{$t('menu_favorecido')}}</li>
								</div>

								<li
									v-if="permission('trial', 'select')"
									@click="subMenuNivel1('showMenuTrial')"
									@mouseenter="subMenuNivel1('showMenuTrial')"
								>
									{{$t('menu_trial')}}
								</li>

								<!-- Adicionado mais um nivel para Trial-->
								<div class="submenu submenu-nivel-1" :class="[showMenuTrial ? 'menu_show' : '']">
									<li v-if="permission('trial',	'select')" @click="navigateTo($event, { path: '/trial' })" @click.middle="navigateTo($event, { path: '/trial' })" class="dropdown-item">{{$t('search')}}</li>
								</div>
							</div>
						</li><!-- Checkout (Payment Link, Trial) -->

						<li v-if="	(payout_ativo == 1 || perm.user.tipo == 'S') &&
									(
										permission('accountpayout', 'select') ||
										permission('payout_payee', 'select') ||
										permission('payout_payout', 'select') ||
										permission('payout_movement', 'select')
									)"
							@click="subMenu('showMenuPayout')"
							@mouseenter="subMenu('showMenuPayout')"
						>
							{{$t('menu_payout')}}
							<div id="menu_sp" class="submenu" :class="[showMenuPayout ? 'menu_show' : '']">
								<li @click="navigateTo($event, { path: '/sp_settings' })"	@click.middle="navigateTo($event, { path: '/sp_settings' })"	v-if="permission('accountpayout', 'select')" class="dropdown-item" >{{$t('menu_payout_settings')}}</li>
								<li @click="navigateTo($event, { path: '/sp_payee' })"		@click.middle="navigateTo($event, { path: '/sp_payee' })"		v-if="permission('payout_payee', 'select')" class="dropdown-item" >{{$t('menu_payout_payee')}}</li>
								<li @click="navigateTo($event, { path: '/sp_payout' })"		@click.middle="navigateTo($event, { path: '/sp_payout' })"		v-if="permission('payout_payout', 'select')" class="dropdown-item" >{{$t('menu_payout_payout')}}</li>
								<li @click="navigateTo($event, { path: '/sp_movement' })"	@click.middle="navigateTo($event, { path: '/sp_movement' })"	v-if="permission('payout_movement', 'select')" class="dropdown-item" >{{$t('menu_payout_movement')}}</li>
							</div>
						</li><!-- payout -->

						<li v-if="permission('payment', 'select') ||
								  permission('accountpayment', 'select') ||
								  permission('paymentremittance', 'select')"
							@click="subMenu('showMenuPayment')"
							@mouseenter="subMenu('showMenuPayment')"
						>
							{{$t('menu_payment')}}
							<div id="menu_payment" class="submenu" :class="[showMenuPayment ? 'menu_show' : '']">
								<li @click="navigateTo($event, { path: '/payment_setting' })"			@click.middle="navigateTo($event, { path: '/payment_setting' })"		v-if="permission('accountpayment', 'select')" class="dropdown-item" >{{$t('menu_payment_setting')}}</li>
								<li @click="navigateTo($event, { path: '/payment_setting_config' })"	@click.middle="navigateTo($event, { path: '/payment_setting_config' })"	v-if="permission('accountpaymentconfig', 'select')" class="dropdown-item" >{{$t('menu_payment_setting_config')}}</li>
								<li @click="navigateTo($event, { path: '/payment' })"					@click.middle="navigateTo($event, { path: '/payment' })"				v-if="permission('payment', 'select')" class="dropdown-item" >{{$t('menu_payment_history')}}</li>
								<li @click="navigateTo($event, { path: '/payment_report' })"			@click.middle="navigateTo($event, { path: '/payment_report' })"			v-if="permission('paymentreport', 'select')" class="dropdown-item" >{{$t('menu_payment_report')}}</li>
								<li @click="navigateTo($event, { path: '/payment_remittance' })"		@click.middle="navigateTo($event, { path: '/payment_remittance' })"		v-if="permission('paymentremittance', 'select')" class="dropdown-item" >{{$t('menu_payment_remittance')}}</li>
								<li @click="navigateTo($event, { path: '/payment_invoice' })"			@click.middle="navigateTo($event, { path: '/payment_invoice' })"		v-if="permission('paymentinvoice', 'select')" class="dropdown-item" >{{$t('menu_payment_invoice')}}</li>
							</div>
						</li><!-- payment -->

						<li v-if="permission('accountwebhook',	'select') ||
								  permission('ipnhistory',		'select') ||
								  permission('webhookhistory',	'select')"
							@click="subMenu('showMenuWebHook')"
							@mouseenter="subMenu('showMenuWebHook')"
						>
							{{$t('menu_webhook')}}
							<div id="menu_sp" class="submenu" :class="[showMenuWebHook ? 'menu_show' : '']">
								<li @click="navigateTo($event, { path: '/config_webhook' })"	@click.middle="navigateTo($event, { path: '/config_webhook' })"		v-if="permission('accountwebhook', 'select') && (autorecurring == 1 || payout_ativo == 1 || payment_ativo || pix_automatico)" class="dropdown-item" >{{$t('menu_webhook_config')}}</li>
								<li @click="navigateTo($event, { path: '/ipn' })"				@click.middle="navigateTo($event, { path: '/ipn' })"				v-if="permission('ipnhistory', 'select')" class="dropdown-item" >{{$t('menu_ipn_history')}}</li>
								<li @click="navigateTo($event, { path: '/history_webhook' })"	@click.middle="navigateTo($event, { path: '/history_webhook' })"	v-if="permission('webhookhistory', 'select') && (autorecurring == 1 || payout_ativo == 1 || payment_ativo || pix_automatico)" class="dropdown-item" >{{$t('menu_webhook_history')}}</li>
							</div>
						</li><!-- webhook -->

						<li @click="navigateTo($event, { path: '/resource' })" @click.middle="navigateTo($event, { path: '/resource' })"  v-if="permission('resource', 'select')" @mouseenter="subMenu()">
							{{$t('menu_resources')}}
						</li><!-- recursos -->
					</ul>
				</div>
			</div>

			<div class="logo float-left">
				<img src="~@/assets/img/logo-fundo-azul-sem-icone.svg">
			</div>

			<div class="float-right right-navbar">
				<div class="float-left welcomeInfo" v-show="merchant_name != ''" v-if="perm.conta.length <= 0">
					<span>{{merchant_name}} <span v-show="perm.user.tipo=='S'">({{merchant_number}})</span> </span>
				</div>

				<div class="float-left" v-show="merchant_name != ''" v-else>
					<b-form-select v-model="xpp" style="width:300px; margin-right:20px; margin-top: 10px;">
						<option v-for="(item, idx) in perm.conta" :key="idx" :value="item.merchant_number">{{item.nome}}</option>
					</b-form-select>
				</div>

				<div class="float-left typeAccountInfo" v-show="merchant_status != ''">
					<span>{{$t('header_account_status')}}: {{merchant_status | merchant_status_translate}}</span>
				</div>

				<span class="float-left typeAccountInfo">|</span>

				<div class="float-left profile_link">
					<router-link to="/accountuserconfig">
						<span>
							<img src="~@/assets/img/icon-profile.png">
							<span>{{username}}</span>
						</span>
					</router-link>
				</div>
				<div class="float-left logout">

					<router-link to="/login?btnclick=1" class="logout">
						<span>
							<img src="~@/assets/img/icon-logout.png">
						</span>
					</router-link>
				</div>

				<div class="float-left returnOverview" v-show="perm.user.tipo=='S' && xpp !='*'">
					[<router-link to="/overview">{{$t('header_return_overview')}}</router-link>]
				</div>

			</div>

			<div class="right-navbar-mobile float-right" ref="dropdownMenu">
				<div class="float-left">
					<span @click="openDropdown = !openDropdown">
						<img src="~@/assets/img/icon-user.svg" class="icon-user">
					</span>
				</div>
				<div class="custom-menu-dropdown" v-if="openDropdown" :style="{maxWidth: getFieldMaxWidth}">
					<ul>
						<li class="username" @click="openDropdown = false">
							<router-link to="/accountuserconfig">
								{{username}}
							</router-link>
						</li>
						<li v-show="merchant_status != ''">
							{{$t('header_account_status')}}:
							<span class="status" :class="accountStatus">{{merchant_status | merchant_status_translate}}</span>
						</li>
						<li v-show="merchant_name != ''" v-if="perm.conta.length <= 0">
							{{merchant_name}}
							<span v-show="perm.user.tipo == 'S'">
								({{merchant_number}})
							</span>
						</li>
						<li v-show="merchant_name != ''" v-else>
							<b-form-select v-model="xpp">
								<option v-for="(item, idx) in perm.conta" :key="idx" :value="item.merchant_number">{{item.nome}}</option>
							</b-form-select>
						</li>
						<li v-show="perm.user.tipo == 'S' && xpp != '*'">
							<router-link to="/overview">[{{$t('header_return_overview')}}]</router-link>
						</li>
						<li class="dropdown-divider"></li>
						<li class="dropdown-logout">
							<router-link to="/login?btnclick=1"> {{$t('header_logout')}}
								<img src="~@/assets/img/icon-logout.svg">
							</router-link>
						</li>
					</ul>
				</div>
			</div>

		</div>

	</div>

</template>



<script>

var aux_timeout;
export default {
	name: 'MenuDash',

	components: {},

	data () {
		return {
			"logado": false,
			"username": '',
			"merchant_name": '',
			"merchant_number": '',
			"merchant_status": '',
			"merchant_cid": '',

			"paylink": 0,
			"xpp": '',
			"realxpp": '',
			"podmanager_ativo": false,
			"autorecurring": 0,
			"payout_ativo": 0,
			"payment_ativo": false,
			"pix_automatico": false,
			"perm": {
				"user": {},
				"perm": {},
				"especial": {}
			},
			"gateway": '',

			"showMenu":				false,
			"showMenuAccount":		false,
			"showMenuReport":		false,
			"showMenuCheckout":		false,
			"showMenuPaymentLink":	false,
			"showMenuTrial":		false,
			"showMenuPayout":		false,
			"showMenuPayment":		false,
			"showMenuWebHook":		false,
			"showMenuPagStream":	false,
			"showMenuCatalogo":		false,

			"openDropdown":	false,
			"shopify": 0,
		}
	},

	beforeMount(){
		//this.perm = JSON.parse(this.$cookie.get('perm'));
		this.perm		= JSON.parse(localStorage.getItem('perm'));
		this.realxpp	= this.$cookie.get('realxpp');
		this.xpp		= this.$cookie.get('xpp');
		this.gateway	= this.$cookie.get('gateway');
	},

	mounted(){

		let token = this.$cookie.get('token');

		if(!token){
			this.$helper.pushRouteTo({ name: 'Login' });
			return;
		}else{
			this.logado = true;
		}

		this.username 	= this.$cookie.get('username');
		this.xpp 		= this.$cookie.get('xpp');

		if(this.xpp == '' ||
			this.xpp == null ||
			this.xpp == '*' ||
			this.xpp == "undefined" ||
			typeof this.xpp == "undefined"){
			this.$router.go(-1);
		}

		this.merchant_name		= this.$cookie.get("merchant_name");
		this.merchant_number	= this.$cookie.get("merchant_number");
		this.merchant_status	= this.$cookie.get("merchant_status");
		this.merchant_cid		= this.$cookie.get("merchant_cid");
		this.paylink			= this.$cookie.get("paylink");
		this.podmanager_ativo	= this.$cookie.get("podmanager_ativo");
		this.autorecurring		= parseInt(this.$cookie.get("autorecurring"));
		this.payout_ativo		= parseInt(this.$cookie.get("payout_ativo"));
		this.shopify			= this.$cookie.get("shopify");
		this.payment_ativo		= localStorage.getItem('payment_ativo') == "Y" ? true : false;
		this.pix_automatico		= localStorage.getItem('pix_automatico') == "1" ? true : false;

	},

	created(){
		document.addEventListener('click', this.documentClick)
	},

	destroyed(){
		document.removeEventListener('click', this.documentClick)
	},

	watch: {
		xpp(newVal, oldVal){
			this.$cookie.set("xpp", newVal, {"SameSite": "None", "Secure":""});

			if(oldVal != null && oldVal != ""){
				this.$router.go();
			}
		}
	},

	computed:{
	},

	methods:{

		podativo(){
			if(this.podmanager_ativo == '1'){
				return true;
			}
			return false;
		},

		getPagstreamBySku(){
			return localStorage.getItem('pagstream_by_sku') == '1';
		},

		getPagstreamCustomerArea(){
			return localStorage.getItem('pagstream_customer_area') == '1';
		},

		navigateTo(event, params){
			// fecha o menu
			this.menuHideClickRoute();

			// compara os paths para evitar erro de NavigationDuplicated
			let from  = this.$route.fullPath;
			let to    = this.$router.resolve(params).route.fullPath;

			// ctrl + click ou botão do meio do mouse
			if(event.ctrlKey === true || event.button === 1){
				let routeData = this.$router.resolve(params);
				window.open(routeData.href, '_blank');
			}else{
				if(from !== to){
					// sendo diferente segue a rota
					this.$router.push(params)
				}
			}
		},

		menuHideClickRoute(){
			clearTimeout(aux_timeout);

			window.setTimeout(() => {
				this.showMenu				= false;
				this.showMenuAccount		= false;
				this.showMenuReport			= false;
				this.showMenuCheckout		= false;
				this.showMenuPaymentLink	= false;
				this.showMenuTrial			= false;
				this.showMenuPayout			= false;
				this.showMenuPayment		= false;
				this.showMenuWebHook		= false;
				this.showMenuPagStream		= false;
				this.showMenuCatalogo		= false;
			}, 210);
		},

		subMenu(el = null){
			this.showMenuAccount		= false;
			this.showMenuReport			= false;
			this.showMenuCheckout		= false;
			this.showMenuPayout			= false;
			this.showMenuPayment		= false;
			this.showMenuWebHook		= false;
			this.showMenuPagStream		= false;
			this.showMenuCatalogo		= false;

			if(el === null){
				return;
			}

			this[el] = !this[el];
		},

		subMenuNivel1(el = null){
			// Controla somente o nivel abaixo do menu pai, pois
			// o mesmo deve permanecer aberto.

			this.showMenuPaymentLink	= false;
			this.showMenuTrial			= false;

			if(el === null){
				return;
			}

			this[el] = !this[el];
		},

		openMenu(canClose){
			clearTimeout(aux_timeout);
			if(canClose){
				this.showMenu=!this.showMenu;
			}else{
				setTimeout(() => {
					this.showMenu = true;
				}, 200);
			}
			document.querySelector(".menu_compacto").focus();
		},

		closeMenu(){

			this.menuHideClickRoute();

			clearTimeout(aux_timeout);
			aux_timeout = window.setTimeout(() => {
				this.showMenu=false;
			}, 450);
		},

		documentClick(e){
			let el = this.$refs.dropdownMenu;
			let target = e.target;

			if(el !== target && !el.contains(target)){
				this.openDropdown = false;
			}
		},
	},

	computed: {
		accountStatus(){
			if(!this.merchant_status){
				return "";
			}

			let value = this.merchant_status.toString();
			let ret = '';

			if(value == 'T'){
				ret = 'status-test';
			}else if(value == '-' || value == 'I' || value == '#'){
				ret = 'status-closed';
			}else{
				ret = 'status-live';
			}

			return ret;
		},

		getFieldMaxWidth(){
			let width = (this.merchant_name.length * 3);

			if(width < 60){
				width = 60;
			}

			if(width > 95){
				width = 95;
			}

			return width + '%';
		},
	},

	filters:{
		merchant_status_translate(value){
			if(!value){
				return '';
			}

			value = value.toString();

			var ret = '';

			if(value == 'T'){
				ret = 'TEST';
			}else if(value == '-' || value == 'I'){
				ret = 'CLOSED';
			}else if(value == '#'){
				ret = 'MAINTENANCE';
			}else{
				ret = 'LIVE';
			}

			return ret;
		}
	}
}

</script>
